<div>
    <div class="dm-tabs">
        <div *ngFor="let tab of tabsContent">
            <span [id]="tab.id" class="set-focus" [ngClass]="{'dm-tabs-active' : tab?.isActive}" tabindex="0"
                (click)="toggleTab(tab)" (keyup.enter)="toggleTab(tab)" (keyup.Space)="toggleTab(tab)"
                (keyup.arrowright)="focusForNavBarArrowKey(tab.id, 'right')"
                (keyup.arrowleft)="focusForNavBarArrowKey(tab.id, 'left')">{{tab?.displayName}}</span>
        </div>
    </div>
</div>